import { Button } from 'ccs-ui-components';
import { useTranslation } from 'react-i18next';
import classes from './CemHeader.module.scss';

interface HeaderProps {
  cemRootNodeName: string | undefined;
  viewJourneyInitiated: boolean | undefined;
  cemName: string | undefined;
  isStatusActiveOrInactive: boolean;
  deleteCompensatoryEventMapHandler: () => void;
  flowItemLength: number;
  cancelCEMHandler: () => void;
  saveCompensatoryEventMapHandler: () => void;
  ingressEvent: string;
  cemSaveBtn: boolean
}

const CemHeader: React.FC<HeaderProps> = ({ cemRootNodeName, viewJourneyInitiated, cemName, isStatusActiveOrInactive, deleteCompensatoryEventMapHandler, flowItemLength, cancelCEMHandler, saveCompensatoryEventMapHandler, ingressEvent, cemSaveBtn }: HeaderProps) => {
  const { t: translate } = useTranslation();
  return (
    <div className={classes['compensatory-wrapper']}>
      <div className={classes['text-wrapper']}>
        <i className="bi bi-exclamation-circle" />
        <p className="m-0">{translate('journey_builder_component.msg_compensatory', {
          replace: { compensatoryName: cemRootNodeName }
        })}
        </p>
      </div>
      <div className={classes['button-wrapper']}>
        {!viewJourneyInitiated && cemName && !isStatusActiveOrInactive && (
          <Button
            variant="primary"
            className={classes['button-delete']}
            onClick={deleteCompensatoryEventMapHandler}
            data-testid="deleteCEM"
            disabled={flowItemLength < 2}
          >
            <i className="bi bi-trash" />
            {translate('journey_builder_component.btn_delete')}
          </Button>
        )}

        <Button
          variant="primary"
          className={classes['button-delete']}
          onClick={cancelCEMHandler}
          data-testid="cancelCEM"
        >
          {translate('journey_builder_component.btn_cancel_cem')}
        </Button>

        {!viewJourneyInitiated && (
          <Button
            variant="primary"
            className={classes['button-return']}
            onClick={saveCompensatoryEventMapHandler}
            disabled={flowItemLength < 2 || !ingressEvent || !cemSaveBtn}
            data-testid="returnFromCEM"
          >
            {translate('journey_builder_component.btn_save_cem')}
          </Button>
        )}
      </div>
    </div>
  );
};

export default CemHeader;
